import { clamp } from 'lodash';
import React, { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { roundedDurationSelector } from '../../ecg/selectors/ecg.selectors';
import { timestampSelector } from '../../navigation/selectors/navigation.selectors';
import { roundPixel } from '../../utils/math';
import { useStrip } from '../hooks/useStrip';
import { getExtent } from '../utils/scale';

type Props = PropsWithChildren<{
  contentType?: 'pattern' | 'default';
}>;

export const StripPosition: React.FC<Props> = ({
  children,
  contentType = 'default',
}) => {
  const ecgDuration = useSelector(roundedDurationSelector);
  const timestamp = useSelector(timestampSelector);
  const { xScale, offset, onset } = useStrip();

  const width = getExtent(xScale.range());
  const clampedPosition = clamp(
    xScale(timestamp) - width / 2,
    0,
    xScale(onset + ecgDuration + offset) - width,
  );
  const correctedOffset =
    contentType === 'pattern' ? clampedPosition % width : clampedPosition;

  return (
    <g
      className='strip-position'
      transform={`translate(${-roundPixel(correctedOffset)})`}
    >
      {children}
    </g>
  );
};
